import { Injectable } from '@angular/core';
import {Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, from, EMPTY } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SopoLoadingService } from 'src/app/shared/services/sopo-loading/sopo-loading.service';
import { 
    ConversationAction, 
    ConversationActionType, 
    LoadConversationAction, 
    LoadConversationSucceededAction, 
    LoadConversationFailedAction, 
    SendMessageAction, 
    SendMessageSucceededAction, 
    SendMessageFailedAction, 
    LoadMessagesAction, 
    LoadMessagesSucceededAction, 
    LoadMessagesFailedAction, 
    EnteredConversationAction,
    LeftConversationAction
} from './conversation.actions';
import { ConversationService } from '../../firebase/conversation.service';


@Injectable()
export class ConversationEffects {

    
    loadConversation$: Observable < ConversationAction > = createEffect(() => this.actions$
        .pipe(
            ofType(ConversationActionType.LOAD_CONVERSATION),
            switchMap((action: LoadConversationAction) => {
                return from(this.conversationService.loadConversation(action.conversationID)
                    .then(conversation => {
                        return new LoadConversationSucceededAction(conversation);
                    })
                    .catch(error => {
                        return new LoadConversationFailedAction({
                            'error': error
                        });
                    })
                );
            })
        ));

    
    sendMessage$: Observable < ConversationAction > = createEffect(() => this.actions$
        .pipe(
            ofType(ConversationActionType.SEND_MESSAGE),
            switchMap((action: SendMessageAction) => {
                return from(this.conversationService.sendMessage(action.conversationID, action.message)
                    .then(() => {
                        return new SendMessageSucceededAction();
                    })
                    .catch(error => {
                        return new SendMessageFailedAction({
                            'error': error
                        });
                    })
                );
            })
        ));

    
    loadMessages$: Observable < ConversationAction > = createEffect(() => this.actions$
        .pipe(
            ofType(ConversationActionType.LOAD_MESSAGES),
            switchMap((action: LoadMessagesAction) => {
                return from(this.conversationService.loadMessages(action.conversationID)
                    .then(messages => {
                        return new LoadMessagesSucceededAction(messages);
                    })
                    .catch(error => {
                        return new LoadMessagesFailedAction({
                            'error': error
                        });
                    })
                );
            })
        ));

    
    enteredConversation$ = createEffect(() => this.actions$
        .pipe(
            ofType(ConversationActionType.ENTERED_CONVERSATION),
            switchMap((action: EnteredConversationAction) => {
                return from(this.conversationService.enteredConversation(action.conversationID));
            })
        ), {dispatch: false});

    
    leftConversation$ = createEffect(() => this.actions$
        .pipe(
            ofType(ConversationActionType.LEFT_CONVERSATION),
            switchMap((action: LeftConversationAction) => {
                return from(this.conversationService.leftConversation(action.conversationID));
            })
        ), {dispatch: false});
        
    constructor(private conversationService: ConversationService,
        private actions$: Actions,
        private loadingCtrl: SopoLoadingService) { }
}
